// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__11jB3","title":"Header_title__Z9BOs","left":"Header_left__2drWc","clinicName":"Header_clinicName__2nKkU"};